// extracted by mini-css-extract-plugin
module.exports = {"get__ecard_area":"style_get__ecard_area__1dMoN","modes":"style_modes__1McLd","salutation":"style_salutation__i50VN","basic":"style_basic__20FTO","details":"style_details__37f4O"};